import { render, staticRenderFns } from "./openId.vue?vue&type=template&id=63a6aa22"
import script from "./openId.vue?vue&type=script&lang=js"
export * from "./openId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports